var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFouchainLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 50,
    viewBox: "0 0 126 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3794 21.0647L23.7571 22.0749V15.2667L6.86401 39.4114C7.40161 39.8668 7.96394 40.2938 8.5493 40.6902L22.3794 21.0647Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.757 15.1758L17.6473 17.5947L19.0007 18.5874L5.34033 37.9737C5.82178 38.4794 6.33048 38.9592 6.86347 39.4113L23.7566 15.2667V15.1758H23.757Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4132 16.9214L7.3035 19.3165L8.63137 20.2903L1.1167 31.1068C1.38194 31.8531 1.69243 32.5776 2.04357 33.2782L13.4136 16.9575L13.4132 16.9214Z",
    fill: "url(#paint0_linear_300_102)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0067 22.7659L13.4125 23.7971V16.957L2.04248 33.2778C2.40242 33.996 2.80509 34.689 3.24883 35.3519L12.0067 22.7659Z",
    fill: "url(#paint1_linear_300_102)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0993 14.4588L24.1975 31.3427V27.4362L34.7308 12.4903C35.2265 13.1146 35.684 13.7746 36.0993 14.4588Z",
    fill: "url(#paint2_linear_300_102)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7307 12.4899L24.1975 27.4358L20.7795 28.9229L33.418 10.9952C33.8789 11.4704 34.3188 11.9694 34.7307 12.4899Z",
    fill: "url(#paint3_linear_300_102)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 31.5233L18.317 32.4192L11.3701 42.2749C11.9722 42.5494 12.5924 42.7899 13.2259 43.0028L23.1793 28.8789L17.0952 31.5233Z",
    fill: "url(#paint4_linear_300_102)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6929 34.8952L23.2047 36.0039V28.868L23.1792 28.8793L13.2258 43.0032C13.9775 43.2558 14.7485 43.467 15.5384 43.6262L21.6929 34.8952Z",
    fill: "url(#paint5_linear_300_102)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3972 6.78996C23.8937 6.78996 27.9979 8.4585 31.1343 11.2052L32.0385 9.92254C28.6407 6.99528 24.2238 5.21948 19.3976 5.21948C8.70174 5.21948 0 13.9212 0 24.6171C0 26.1096 0.175149 27.5611 0.495697 28.9577L1.75569 27.1701C1.63585 26.3359 1.57089 25.484 1.57089 24.6167C1.57006 14.7714 9.55151 6.78996 19.3972 6.78996Z",
    fill: "url(#paint6_linear_300_102)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9261 16.3188L35.8752 17.8097C36.743 19.9073 37.224 22.2056 37.224 24.6171C37.224 34.4627 29.2426 42.4442 19.3969 42.4442C19.104 42.4442 18.8132 42.4362 18.5241 42.422L17.469 43.9183C18.1034 43.9812 18.7466 44.0147 19.3969 44.0147C30.0927 44.0147 38.7945 35.3129 38.7945 24.6171C38.7949 21.6492 38.1228 18.8363 36.9261 16.3188Z",
    fill: "url(#paint7_linear_300_102)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62301 21.7066C4.99613 14.2472 11.5471 8.57835 19.3969 8.57835C23.5041 8.57835 27.2539 10.1317 30.0945 12.6797L31.134 11.2052C27.9981 8.45853 23.8934 6.78998 19.3969 6.78998C9.55127 6.78998 1.56982 14.7714 1.56982 24.6171C1.56982 25.4845 1.63519 26.3363 1.75461 27.1706L3.36489 24.8861C3.33682 23.7003 3.44912 22.6506 3.62301 21.7066Z",
    fill: "url(#paint8_linear_300_102)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2236 24.6171C37.2236 22.2057 36.7422 19.9077 35.8748 17.8097L34.6228 19.5859C35.1474 21.1694 35.4357 22.8597 35.4357 24.6171C35.4357 33.3339 28.4448 40.4434 19.7757 40.6462L18.5237 42.422C18.8132 42.4358 19.104 42.4442 19.3965 42.4442C29.2422 42.4438 37.2236 34.4623 37.2236 24.6171Z",
    fill: "url(#paint9_linear_300_102)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.656 7.74099V14.9569H60.6679C61.709 14.9569 62.4045 14.7999 62.7546 14.4857C63.2213 14.0729 63.4815 13.3459 63.5354 12.3048H64.0335V18.6591H63.5354C63.4097 17.7706 63.2841 17.2007 63.1584 16.9494C62.9969 16.6353 62.7321 16.3884 62.3641 16.2089C61.9962 16.0294 61.4307 15.9397 60.6679 15.9397H56.656V21.9575C56.656 22.7652 56.6919 23.2588 56.7637 23.4383C56.8355 23.6089 56.9612 23.748 57.1407 23.8557C57.3202 23.9544 57.6612 24.0038 58.1638 24.0038H61.2602C62.2923 24.0038 63.0418 23.932 63.5085 23.7884C63.9752 23.6448 64.4239 23.3621 64.8547 22.9402C65.4112 22.3838 65.9811 21.5446 66.5645 20.4227H67.103L65.5278 25H51.4595V24.5019H52.1057C52.5365 24.5019 52.9448 24.3987 53.3308 24.1922C53.618 24.0486 53.8109 23.8332 53.9097 23.546C54.0174 23.2588 54.0712 22.671 54.0712 21.7824V9.92193C54.0712 8.76415 53.9545 8.05063 53.7212 7.78138C53.3981 7.42238 52.8596 7.24288 52.1057 7.24288H51.4595V6.74476H65.5278L65.7298 10.7431H65.2047C65.0163 9.78282 64.8054 9.12315 64.572 8.76415C64.3476 8.40515 64.0111 8.13141 63.5623 7.94293C63.2033 7.80831 62.5706 7.74099 61.6641 7.74099H56.656ZM79.0308 25L71.9764 9.63922V21.8363C71.9764 22.9582 72.0976 23.6582 72.3399 23.9365C72.672 24.3134 73.197 24.5019 73.915 24.5019H74.5612V25H68.2069V24.5019H68.8531C69.625 24.5019 70.1724 24.2685 70.4955 23.8018C70.693 23.5146 70.7917 22.8595 70.7917 21.8363V9.90847C70.7917 9.10071 70.702 8.51734 70.5225 8.15833C70.3968 7.89806 70.1635 7.68266 69.8224 7.51213C69.4903 7.33263 68.9518 7.24288 68.2069 7.24288V6.74476H73.3765L80.0001 21.0285L86.516 6.74476H91.6856V7.24288H91.0529C90.272 7.24288 89.7201 7.47623 89.397 7.94293C89.1995 8.23013 89.1008 8.88531 89.1008 9.90847V21.8363C89.1008 22.9582 89.2264 23.6582 89.4777 23.9365C89.8098 24.3134 90.3349 24.5019 91.0529 24.5019H91.6856V25H83.9312V24.5019H84.5774C85.3582 24.5019 85.9057 24.2685 86.2198 23.8018C86.4173 23.5146 86.516 22.8595 86.516 21.8363V9.63922L79.4751 25H79.0308ZM110.91 25H106.037L99.8574 16.4647C99.3997 16.4827 99.0272 16.4917 98.74 16.4917C98.6233 16.4917 98.4977 16.4917 98.363 16.4917C98.2284 16.4827 98.0893 16.4737 97.9457 16.4647V21.769C97.9457 22.9178 98.0714 23.6313 98.3227 23.9095C98.6637 24.3044 99.1753 24.5019 99.8574 24.5019H100.571V25H92.7492V24.5019H93.4357C94.2076 24.5019 94.7596 24.2506 95.0916 23.748C95.2801 23.4698 95.3744 22.8101 95.3744 21.769V9.97578C95.3744 8.82697 95.2487 8.11346 94.9974 7.83523C94.6474 7.44033 94.1268 7.24288 93.4357 7.24288H92.7492V6.74476H99.3997C101.338 6.74476 102.765 6.88837 103.681 7.17557C104.605 7.45379 105.386 7.97435 106.023 8.73722C106.669 9.49113 106.993 10.3931 106.993 11.4432C106.993 12.5651 106.625 13.5389 105.889 14.3646C105.162 15.1903 104.031 15.7737 102.496 16.1147L106.266 21.3516C107.127 22.5543 107.868 23.3531 108.487 23.748C109.106 24.1429 109.914 24.3942 110.91 24.5019V25ZM97.9457 15.6166C98.1162 15.6166 98.2643 15.6211 98.39 15.6301C98.5156 15.6301 98.6188 15.6301 98.6996 15.6301C100.441 15.6301 101.751 15.2531 102.631 14.4992C103.519 13.7453 103.963 12.785 103.963 11.6182C103.963 10.4784 103.604 9.55395 102.886 8.84492C102.177 8.12692 101.235 7.76792 100.059 7.76792C99.5388 7.76792 98.8342 7.85318 97.9457 8.02371V15.6166ZM124.952 6.74476L125.154 11.0259H124.642C124.543 10.272 124.409 9.73345 124.238 9.41035C123.96 8.8898 123.587 8.50836 123.121 8.26603C122.663 8.01473 122.057 7.88908 121.303 7.88908H118.732V21.8363C118.732 22.9582 118.853 23.6582 119.095 23.9365C119.436 24.3134 119.961 24.5019 120.671 24.5019H121.303V25H113.562V24.5019H114.208C114.98 24.5019 115.528 24.2685 115.851 23.8018C116.048 23.5146 116.147 22.8595 116.147 21.8363V7.88908H113.953C113.1 7.88908 112.494 7.95191 112.135 8.07756C111.669 8.24808 111.269 8.57567 110.937 9.06033C110.605 9.54498 110.408 10.2002 110.345 11.0259H109.833L110.049 6.74476H124.952Z",
    fill: "url(#paint10_linear_300_102)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6009 45.2341V36.9321L58.0166 43.3195H57.1742L53.5746 36.9321V45.2341H52.196V34.3588H53.6512L57.5877 41.4201L61.5396 34.3588H62.9795V45.2341H61.6009ZM69.3519 34.3588H70.516L74.958 45.2341H73.4876L72.2009 42.0481H67.6363L66.365 45.2341H64.8945L69.3519 34.3588ZM71.8946 40.9759L69.9339 35.9518L67.912 40.9759H71.8946ZM76.869 45.2341V34.3588H81.5255C82.0054 34.3588 82.4445 34.4609 82.8428 34.6651C83.241 34.8591 83.5882 35.1246 83.8844 35.4616C84.1805 35.7884 84.4103 36.1611 84.5737 36.5798C84.737 36.9883 84.8187 37.4069 84.8187 37.8358C84.8187 38.3362 84.7217 38.811 84.5277 39.2603C84.3439 39.7097 84.0784 40.0926 83.7312 40.4091C83.3942 40.7257 82.996 40.9453 82.5364 41.0678L85.171 45.2341H83.6087L81.1272 41.3282H78.2476V45.2341H76.869ZM78.2476 40.1028H81.5408C81.9186 40.1028 82.2454 40.0007 82.5211 39.7965C82.8071 39.582 83.0266 39.3012 83.1798 38.954C83.3432 38.6068 83.4249 38.2341 83.4249 37.8358C83.4249 37.4274 83.333 37.0546 83.1491 36.7177C82.9653 36.3705 82.7254 36.0947 82.4292 35.8905C82.1331 35.6863 81.8063 35.5842 81.4489 35.5842H78.2476V40.1028ZM87.3955 45.2341V34.3741H88.7741V40.3785L94.3803 34.3588H95.8661L91.5006 39.1531L96.1111 45.2341H94.5641L90.6275 39.9803L88.7741 41.9103V45.2341H87.3955ZM105.23 44.0087V45.2341H97.8473V34.3588H105.092V35.5842H99.2258V39.1072H104.327V40.256H99.2258V44.0087H105.23ZM115.424 35.5842H111.671V45.2341H110.292V35.5842H106.539V34.3588H115.424V35.5842ZM123.837 36.6411C123.714 36.4981 123.551 36.3602 123.347 36.2275C123.142 36.0947 122.913 35.9773 122.657 35.8752C122.402 35.7629 122.121 35.6761 121.815 35.6148C121.519 35.5433 121.207 35.5076 120.88 35.5076C120.043 35.5076 119.425 35.6659 119.027 35.9824C118.629 36.299 118.43 36.733 118.43 37.2844C118.43 37.6724 118.532 37.9788 118.736 38.2034C118.94 38.4281 119.252 38.6119 119.67 38.7549C120.099 38.8978 120.64 39.0459 121.294 39.1991C122.05 39.3625 122.703 39.5616 123.255 39.7965C123.806 40.0313 124.23 40.3479 124.526 40.7461C124.822 41.1342 124.97 41.655 124.97 42.3085C124.97 42.8293 124.868 43.2837 124.664 43.6718C124.47 44.0496 124.194 44.3661 123.837 44.6214C123.479 44.8665 123.061 45.0503 122.581 45.1729C122.101 45.2852 121.58 45.3414 121.018 45.3414C120.467 45.3414 119.926 45.2852 119.395 45.1729C118.874 45.0503 118.379 44.8767 117.909 44.6521C117.439 44.4274 117 44.1466 116.592 43.8096L117.25 42.6455C117.414 42.8191 117.623 42.9927 117.878 43.1663C118.144 43.3297 118.44 43.4828 118.767 43.6258C119.104 43.7688 119.466 43.8862 119.854 43.9781C120.242 44.0598 120.64 44.1006 121.049 44.1006C121.825 44.1006 122.428 43.9628 122.856 43.6871C123.285 43.4011 123.5 42.9876 123.5 42.4464C123.5 42.0379 123.377 41.7111 123.132 41.466C122.897 41.221 122.545 41.0167 122.075 40.8534C121.605 40.69 121.034 40.5266 120.36 40.3632C119.624 40.1794 119.007 39.9803 118.506 39.7658C118.006 39.5412 117.628 39.2501 117.373 38.8927C117.128 38.5353 117.005 38.0707 117.005 37.4988C117.005 36.8045 117.174 36.2173 117.511 35.7373C117.848 35.2574 118.312 34.8949 118.905 34.6498C119.497 34.4047 120.166 34.2822 120.911 34.2822C121.401 34.2822 121.856 34.3332 122.274 34.4354C122.703 34.5375 123.101 34.6804 123.469 34.8642C123.837 35.0481 124.174 35.2676 124.48 35.5229L123.837 36.6411Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_102",
    x1: 1.1167,
    y1: 25.0998,
    x2: 13.4136,
    y2: 25.0998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_102",
    x1: 2.04248,
    y1: 26.1545,
    x2: 13.4125,
    y2: 26.1545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_102",
    x1: 24.1975,
    y1: 21.9165,
    x2: 36.0993,
    y2: 21.9165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_300_102",
    x1: 20.7795,
    y1: 19.9591,
    x2: 34.7307,
    y2: 19.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_300_102",
    x1: 11.3701,
    y1: 35.9408,
    x2: 23.1793,
    y2: 35.9408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_300_102",
    x1: 13.2258,
    y1: 36.2471,
    x2: 23.2047,
    y2: 36.2471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_300_102",
    x1: 0,
    y1: 17.0886,
    x2: 32.0385,
    y2: 17.0886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_300_102",
    x1: 17.469,
    y1: 30.1668,
    x2: 38.7945,
    y2: 30.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_300_102",
    x1: 1.56982,
    y1: 16.9803,
    x2: 31.134,
    y2: 16.9803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_300_102",
    x1: 18.5237,
    y1: 30.127,
    x2: 37.2236,
    y2: 30.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_300_102",
    x1: 50.894,
    y1: 16,
    x2: 125.949,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F8BC36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537052,
    stopColor: "#F8EB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#E89B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFouchainLogoLight);
export default __webpack_public_path__ + "static/media/fouchain-logo-light.91a2449d6760ca409fe88f197a219c3f.svg";
export { ForwardRef as ReactComponent };